import { Box } from "@mui/material";
import vehicleImage from "app/assets/vechile.svg";
import React from "react";
import { useTranslation } from "react-i18next";
import { DiagramPageData } from "../types";
import { InfoCard } from "./InfoCard";
import { useStyles } from "./styles";

type SpecDiagramProps = {
  pageData: DiagramPageData;
};

export const SpecDiagram = ({ pageData }: SpecDiagramProps) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <>
      <Box className={styles.infoRow}>
        <InfoCard
          titleKey="WORK_ORDER.DIAGRAM.SECTIONS.CUSTOMER_VEHICLE"
          fields={pageData.customerVehicle ?? []}
          singleColumn
        />
        <InfoCard
          titleKey="WORK_ORDER.DIAGRAM.SECTIONS.PROJECT_INFO"
          fields={pageData.projectInfo ?? []}
          singleColumn
        />
      </Box>

      <InfoCard
        titleKey="WORK_ORDER.DIAGRAM.SECTIONS.TECHNICAL_SPEC"
        fields={pageData.technicalSpec ?? []}
        columnFlow
        fullWidth
        autoHeight
      />

      <Box className={styles.diagramImageSection}>
        <img
          src={vehicleImage}
          alt={t("WORK_ORDER.DIAGRAM.DIAGRAM_ALT")}
          className={styles.diagramImage}
        />
      </Box>
    </>
  );
};
